import { SpecialButton } from '@chegg-wt/core/theme/fanta/button'
import styled from 'styled-components'
import { font, colors } from '@chegg-ui/theme'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Button = styled(SpecialButton)`
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
    max-width: 200px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-bottom: 16px;
  }
  & input {
    ${AspiraStack};
    border: ${({ theme }) => `2px solid ${theme.colors.greyE5}`};
    height: 44px;
    width: 100%;
    padding-left: 20px;
    ::placeholder {
      font-size: 15px;
    }
    @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-right: none;
    }
  }
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
    flex-direction: row;
    & > * + * {
      margin-top: 0;
    }
    & > div {
      width: 100%;
    }
  }
`

export const ManualCiteLink = styled.a`
  ${AspiraStack};
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  text-decoration: none;
  font-size: ${font.size.px16};
  font-weight: ${font.weight.bold};
  letter-spacing: 0;
  line-height: ${font.lineHeight.sm};
  &:hover {
    text-decoration: underline;
  }
  text-align: left;

  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.extraSmall(theme), 20)}) {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
`
